/**
 * ArloRail.js - Arlo recommendation rail wrapper
 *
 * Owns everything Arlo-specific so CategoryRail stays generic: the
 * attribution caption (a compliance requirement whenever the payload says
 * required — copy/logo/link come from the payload, never hardcoded) and
 * telemetry (rail_impression on mount, tile_tapped per click,
 * attribution_rendered once per mounted surface).
 */
import React, { useEffect, useRef } from 'react';
import CategoryRail from './CategoryRail';
import arloService from '../services/ArloService';
import ArloAttributionCaption from './ArloAttributionCaption';

const ArloRail = ({ rail }) => {
  const attributionReported = useRef(false);
  const attribution = rail?.attribution;
  const showAttribution = Boolean(attribution?.required);
  const railId = rail?.railId;

  useEffect(() => {
    arloService.track('rail_impression', { rail_id: railId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (showAttribution && !attributionReported.current) {
      attributionReported.current = true;
      arloService.attributionRendered();
    }
  }, [showAttribution]);

  if (!rail) {return null;}

  return (
    <CategoryRail
      category={rail}
      hideSeeAll
      titleCaption={showAttribution ? <ArloAttributionCaption attribution={attribution} /> : null}
      onTileClick={channel =>
        arloService.track('tile_tapped', {
          rec_id: channel.arloRecId,
          content_id: channel.slug,
        })
      }
    />
  );
};

export default ArloRail;
